import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyItDidntWork() {
  const reasons = [{
    title: 'Las dietas de "solo lechuga"',
    description: 'estresan tu sistema y disparan el cortisol, inflamándote más.'
  }, {
    title: 'Los laxantes y tés "detox"',
    description: 'dañan tu microbiota y crean una dependencia peligrosa.'
  }, {
    title: 'Los planes genéricos',
    description: 'usan ingredientes costosos que no encuentras en tu mercado local.'
  }, {
    title: 'Ignorar la conexión emocional',
    description: 'entre tus emociones y tu colon hace que cualquier resultado sea temporal.'
  }];
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#FAFAF7'
  }} data-id="element-240">
      <div className="max-w-4xl mx-auto px-4" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-242">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          color: '#1A1A1A'
        }} data-id="element-243">
            ¿Por qué lo que has intentado no ha funcionado?
          </h2>

          <p className="text-center text-lg mb-12" style={{
          color: '#4A4A4A'
        }} data-id="element-244">
            No es tu culpa. Estos métodos están diseñados para fallar:
          </p>

          <div className="grid gap-4 md:gap-6" data-id="element-245">
            {reasons.map((reason, index) => <motion.div key={index} className="flex items-start gap-4 p-5 md:p-6 bg-white rounded-xl shadow-sm border-l-4" style={{
            borderColor: '#C9A96E'
          }} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-246">
                <XCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5 text-red-400" data-id="element-247" />
                <p className="text-base md:text-lg" style={{
              color: '#4A4A4A'
            }} data-id="element-248">
                  <strong style={{
                color: '#1A1A1A'
              }} data-id="element-249">
                    {reason.title}
                  </strong>{' '}
                  {reason.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}